import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GridFormComponent as UiKitGridFormComponent } from 'nebula-ui-kit';

export type GridBreakpoint = {
  minWidth?: number;
  maxWidth?: number;
  columns: number;
  gap?: string;
  autoFit?: boolean;
};

export type GridPreset =
  | 'auto'
  | '4cols'
  | '3cols'
  | '2cols'
  | '1col'
  | 'responsive'
  | '3cols-responsive';

@Component({
  selector: 'app-grid-form',
  standalone: true,
  imports: [CommonModule, UiKitGridFormComponent],
  template: `
    <lib-grid-form
      [preset]="$any(preset)"
      [columns]="columns"
      [gap]="gap"
      [wrapperClass]="wrapperClass"
      [ariaLabel]="ariaLabel"
    >
      <ng-content></ng-content>
    </lib-grid-form>
  `,
})
export class GridFormComponent {
  @Input() preset: GridPreset = 'responsive';
  @Input() columns = 4;
  @Input() gap = '1.5rem';
  @Input() wrapperClass = '';
  @Input() ariaLabel?: string;
}
